module.exports = __webpack_public_path__ + "img/eh.1054a708.svg";